"use strict";

/**
 * @generated SignedSource<<24bdb8934e561eea88cd43688cc7a10d>>
 * @relayHash 15f8e96e7cef931f41dd89873e489c31
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID debbbd9590458cfbaadc9d79a30ffa02906094f4e07be9cdf39dd20710e42a5f

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "supplierId"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "id",
      "variableName": "supplierId"
    }];
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useAccountSuppliersMetaSupplierQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [{
          "args": null,
          "kind": "FragmentSpread",
          "name": "useSupplierMetaSupplier_Supplier"
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useAccountSuppliersMetaSupplierQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dbId",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }],
          "type": "Supplier",
          "abstractKey": null
        }, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }],
          "type": "Node",
          "abstractKey": "__isNode"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "debbbd9590458cfbaadc9d79a30ffa02906094f4e07be9cdf39dd20710e42a5f",
      "metadata": {},
      "name": "useAccountSuppliersMetaSupplierQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "ab11ac53f6c0f9ba404cca272db84405";
export default node;